import request from '@/utils/request'
export const queryPage = '/icps/system/sign/goodService/outStorage/querypage'
/**周材出库页面-提交*/
export function saveOutStorage(data) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/saveOutStorage',
    method: 'post',
    data
  })
}
/**周材出库页面-修改*/
export function updateStorage(data) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/updateStorage',
    method: 'post',
    data
  })
}
/**:周材出库页面-工程履约工程列表*/
export function queryListMaterials(params) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/queryListMaterials',
    method: 'get',
    params
  })
}
/**:获取工程负责人列表*/
export function queryList(data) {
  return request({
    url: '/icps/system/sign/goodService/engineeringPrincipal/queryList',
    method: 'post',
    data
  })
}
/**:获取工地周材设置列表*/
export function queryEngineeringPersonnel(params) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/queryEngineeringPersonnel',
    method: 'get',
    params
  })
}
/**获取用户列表*/
export function get_simple_user_listBycompanyId(params) {
  return request({
    url: '/base/system/user/get_simple_user_listBycompanyId',
    method: 'get',
    params,
  })
}
/**.添加工程负责人
*/
export function saveResord(data) {
  return request({
    url: '/icps/system/sign/goodService/engineeringPrincipal/saveResord',
    method: 'post',
    data,
  })
}
/**.添加工程负责人new
*/
export function updatePeople(data) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/updatePeople',
    method: 'post',
    data,
  })
}
/**获取周材名列表*/
export function queryNameList(params) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/queryNameList',
    method: 'get',
    params
  })
}
/**获取规格和类型列表*/
export function querySpecification(data) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/querySpecification',
    method: 'post',
    data
  })
}
/**周材出库页面-获取车辆列表*/
export function queryListCar(data) {
  return request({
    url: '/icps/system/sign/basics/car/queryListCar',
    method: 'post',
    data
  })
}
/**获取周材出库详情列表*/
export function particularsList(data) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/queryDetailList',
    method: 'post',
    data
  })
}
/**根据工程ID获取巡检安全情况 */
export function patrolSafety(params) {
  return request({
    url: '/icps/system/sign/goodService/patrolSafety/queryList',
    method: 'get',
    params
  })
}
/**根据工程ID获取巡检数量/质量情况  */
export function patrolQuality(params) {
  return request({
    url: '/icps/system/sign/goodService/patrolQuality/queryList',
    method: 'get',
    params
  })
}
/**根据工程ID获取巡检数量/质量情况  */
export function hiddenDanger(data) {
  return request({
    url: '/icps/system/sign/goodService/hiddenDanger/queryList',
    method: 'post',
    data
  })
}

/**根据工程ID获取巡检数量/质量情况  */
export function judePrincipal(params) {
  return request({
    url: '/icps/system/sign/goodService/engineeringPrincipal/judePrincipal',
    method: 'get',
    params
  })
}

/**修改明细*/
export function getUpdateResordList(params) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/getUpdateResordList',
    method: 'get',
    params
  })
}

/**修改明细*/
export function queryPageApp(data) {
  return request({
    url: '/icps/system/sign/goodService/transportDetails/queryPageApp',
    method: 'post',
    data
  })
}
/**获取周材出库详情*/
export function queryDetailList(data) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/queryDetailList',
    method: 'post',
    data
  })
}
/**获取修改前出库单详情*/
export function queryBeforeMaterialsDetail(data) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/queryBeforeMaterialsDetail',
    method: 'post',
    data
  })
}
/**获取修改后出库单详情*/
export function queryAfterMaterialsDetail(data) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/queryAfterMaterialsDetail',
    method: 'post',
    data
  })
}

